webpackJsonp([35783957827783],{

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _downloadBlue = __webpack_require__(128);
	
	var _downloadBlue2 = _interopRequireDefault(_downloadBlue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	
	// images
	
	
	var DownloadWhite = function DownloadWhite() {
	  return _react2.default.createElement(
	    'button',
	    { className: 'download-white' },
	    _react2.default.createElement('img', { src: _downloadBlue2.default, alt: 'download arrow' }),
	    'Firefox Developer Edition'
	  );
	};
	
	exports.default = DownloadWhite;
	module.exports = exports['default'];

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _arrowRight = __webpack_require__(125);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TutorialItem = function TutorialItem(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'tutorial-item col-md-6' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.link },
	      _react2.default.createElement('img', { className: 'tutorial-item__img', src: props.photo, alt: '' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      { className: 'tutorial-item__title' },
	      props.title
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      props.desc
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.link },
	      _react2.default.createElement(
	        'button',
	        { className: 'tutorial-item__btn' },
	        'Go to Playground ',
	        _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'arrow' })
	      )
	    )
	  );
	};
	
	exports.default = TutorialItem;
	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TutorialItem = __webpack_require__(80);
	
	var _TutorialItem2 = _interopRequireDefault(_TutorialItem);
	
	var _cssgrid = __webpack_require__(126);
	
	var _cssgrid2 = _interopRequireDefault(_cssgrid);
	
	var _debugger = __webpack_require__(127);
	
	var _debugger2 = _interopRequireDefault(_debugger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// photos
	var TutorialList = function TutorialList() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'tutorial-list' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(_TutorialItem2.default, {
	        photo: _cssgrid2.default,
	        title: 'CSS Grid',
	        desc: 'CSS Grid Layout is completely changing the game for web design. Learn about CSS Grid Layout and the Firefox DevTools layout panel',
	        link: '/css-grid'
	      }),
	      _react2.default.createElement(_TutorialItem2.default, {
	        photo: _debugger2.default,
	        title: 'Debugger',
	        desc: 'Still using console.log for debugging JavaScript? There is a better way! Learn about how to use Firefox Debugger to debug and fix your code.',
	        link: '/debugger'
	      })
	    )
	  );
	};
	
	// components
	exports.default = TutorialList;
	module.exports = exports['default'];

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cssgrid.025372ef.png";

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/debugger.8950e3ca.png";

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(58);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _DownloadWhite = __webpack_require__(79);
	
	var _DownloadWhite2 = _interopRequireDefault(_DownloadWhite);
	
	var _TutorialList = __webpack_require__(81);
	
	var _TutorialList2 = _interopRequireDefault(_TutorialList);
	
	var _DownloadLink = __webpack_require__(16);
	
	var _DownloadLink2 = _interopRequireDefault(_DownloadLink);
	
	var _ffLogo = __webpack_require__(197);
	
	var _ffLogo2 = _interopRequireDefault(_ffLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  width: '80px'
	};
	
	// photos
	
	
	// components
	
	var index = function index() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Hero2.default,
	      null,
	      _react2.default.createElement('img', { className: 'mb6', style: logoStyle, src: _ffLogo2.default, alt: 'logo' }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Firefox DevTools Playground'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 col-md-offset-3 mt3' },
	          _react2.default.createElement(
	            'p',
	            { className: 'mb6' },
	            'Learn, build, improve, and create with Firefox DevTools.'
	          ),
	          _react2.default.createElement(
	            _DownloadLink2.default,
	            { content: 'index-hero' },
	            _react2.default.createElement(_DownloadWhite2.default, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_TutorialList2.default, null)
	  );
	};
	
	exports.default = index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-60ad6e49edd1f1f74531.js